import Span from 'components/Span'
import React from 'react'
import BulletIcon from 'components/Icons/Bullet'
import getSizeGuideLabelDataProductUtil from 'modules/product/utils/get-size-guide-label-data'

/**
 * @param sizeLabel
 * @returns {JSX.Element|undefined}
 */
export default function getSizeGuideLabelElementProductUtil ({ sizeLabel }) {
  if (!sizeLabel) {
    return
  }

  const data = getSizeGuideLabelDataProductUtil({ sizeLabel })
  const hasSlash = sizeLabel.indexOf('/') > -1

  const {
    enoughForLabelShort,
    // sizeLabelArr,
    size
  } = data

  const firstLine = hasSlash
    ? (
      <Span>
        {size} / {enoughForLabelShort}
      </Span>
      )
    : (
      <Span>
        {/* e.g. 1.5 ml <BulletIcon /> 5+ uses */}
        {size} {!!enoughForLabelShort && <BulletIcon />} {enoughForLabelShort}
      </Span>
      )

  // const secondLine = sizeLabelArr[1]
  //   ? (
  //     <>
  //       <br />
  //       <Span style={{ color: '#504F63' }}>
  //         {
  //           capitalizeStringUtil(
  //             removeParenthesisStringUtil(
  //               sizeLabelArr[1]
  //             )
  //           )
  //         }
  //       </Span>
  //     </>
  //     )
  //   : null

  const secondLine = null

  const element = (
    <>
      {firstLine}
      {secondLine}
    </>
  )

  return {
    element,
    firstLine,
    secondLine
  }
}
